module.exports = __webpack_public_path__ + "nu.svg?c44bab22361e115457dcfde18fa9bc2a";